export class RogueCaseUpdates {
  id: number;
  caseId: number;
  updateId: number;
  username: string;
  usernameDisplay: string;
  updateContent: string;
  updateTimestamp: Date;
}
